import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MetadataLoadingStage, UserContextService } from 'src/app/core/services/user-context.service';
import { buildRoutePrefix } from 'src/app/core/util';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent {
  logoUrl: string = "../../assets/images/img-logo.jpg";
  inOnboarding: boolean;
  instanceLoaded: boolean;
  inSystemAdminMode: boolean = false;
  
  constructor (
    public userContextService: UserContextService,
    private router: Router,
    private location: Location
  ) {
    userContextService.OnboardingState$.subscribe((value) => {
      this.inOnboarding = value === 'Ongoing';
    });

    userContextService.MetadataLoadingStage$.subscribe((stage) => {
      this.instanceLoaded = stage >= MetadataLoadingStage.InstanceMetadataLoaded;
    });

    userContextService.SystemAdminMode$.subscribe((value) => {
      this.inSystemAdminMode = value;
    });
  }

  private cachedRouteSegments = {
    "report-list": [],
    "settings": [],
    "chat": [],
    "onboarding": []
  }

  logoEvent() {
    if (this.userContextService.OnboardingState === 'Ongoing') {
      this.goToOnboarding();
    } else if (!this.instanceLoaded) {
      this.goToNoInstance();
    } else {
      this.goToChat();
    }
  }

  goToReports() {
    this.userContextService.LeavePreboarding();
    this.UpdateCachedRouteSegments();
    this.router.navigate(this.getRouteSegments('report-list'));
    this.isVisible = false; // Hide mobile menu
  }

  goToSettings() {
    this.userContextService.LeavePreboarding();
    this.UpdateCachedRouteSegments();
    this.router.navigate(this.getRouteSegments('settings'));
    this.isVisible = false; // Hide mobile menu
  }

  goToChat() {
    this.userContextService.LeavePreboarding();
    this.UpdateCachedRouteSegments();
    this.router.navigate(this.getRouteSegments('chat'));
    this.isVisible = false; // Hide mobile menu
  }

  goToOnboarding() {
    this.UpdateCachedRouteSegments();
    this.router.navigate(this.getRouteSegments('onboarding'));
    this.isVisible = false; // Hide mobile menu
  }

  goToNoInstance() {
    this.router.navigate(['/dashboard/no-instance']);
  }

  getRouteSegments(route: 'report-list' | 'settings' | 'chat' | 'onboarding'): string[] {
    const s = [];

    if (route === 'onboarding' || route === 'settings') {
      s.push(`${route}`);
    } else {
      const prefix = buildRoutePrefix(this.userContextService.CurrentInstance?.ID);
      s.push(prefix, `${route}`);
    }

    const cache = this.GetCachedRouteSegments(route);
    if (cache && cache.length) {
      // we have 1+ cached segments for the route, add them to the s array
      s.push(...cache);
    }
    return s;
  }

  GetCachedRouteSegments(route: 'report-list' | 'settings' | 'chat' | 'onboarding'): string[] {
    return this.cachedRouteSegments[route];
  }

  UpdateCachedRouteSegments() {
    const url = this.location.path();
    const segments = url.split('/').filter(x => x);

    if (url.includes('/onboarding')) {
      const onboardingIndex = segments.indexOf('onboarding');
      const cachableSegments = segments && segments.length > onboardingIndex + 1 ? segments.slice(onboardingIndex + 1) : [];
      this.cachedRouteSegments.onboarding = cachableSegments;
    } else if (url.includes('/settings')) {
      const settingIndex = segments.indexOf('settings');
      const cachableSegments = segments && segments.length > settingIndex + 1 ? segments.slice(settingIndex + 1) : [];
      this.cachedRouteSegments.settings = cachableSegments;
    } else {
      const prefixSegments = buildRoutePrefix(this.userContextService.CurrentInstance?.ID).split('/').filter(x => x);
      const cachableSegments = segments && segments.length > prefixSegments.length ? segments.slice(prefixSegments.length + 1) : [];
      if (url.includes('/report-list')) {
        this.cachedRouteSegments["report-list"] = cachableSegments;
      } 
      else if (url.includes('/chat')) {
        this.cachedRouteSegments.chat = cachableSegments;
      }
    }
  }
  // Mobile Menu Toggle
  isVisible = false;

  openMobileNav(): void {
    this.isVisible = !this.isVisible;
  }

}